<div style="width: 100%; height: 100%; overflow-x: hidden;" 
     [ngStyle]="{'background-color': pageLayoutDataService.bgColor}">
     <app-unsupported-resolution-screen *ngIf="canvasLayoutDataService.width<pageLayoutDataService.minSupportedWidth"></app-unsupported-resolution-screen>

     <ng-container *ngIf="canvasLayoutDataService.width>=pageLayoutDataService.minSupportedWidth">
        <app-loading-screen *ngIf="pageLayoutDataService.loading"></app-loading-screen>
        <div *ngIf="!pageLayoutDataService.loading" 
             class="layout vertical center top"
             style="height: 100%;min-width: 400px;">
          <div *ngIf="pageLayoutDataService.showBreadcrumbs && routingDataService.currentBreadcrumbs && isGreaterThanXs" 
               style="width: 100%; height: 48px; margin-bottom: 5px;">
               <app-breadcrumbs></app-breadcrumbs>
          </div>
               <!-- <div style="height: 40px;" *ngIf="!(showBreadcrumbs && routingDataService.currentBreadcrumbs && isGreaterThanXs)"></div> -->
          <div class="layout vertical center top" 
               [ngClass]="{'middle' : pageLayoutDataService.verticallyCentered}" 
               style="width: 100%; height: 100%;"
               [ngStyle]="{'overflow': pageLayoutDataService.fixedbreadcrumbs==true?'auto':'none'}">
              <ng-content select="[slot=body]"></ng-content>
              
          </div>
          <!-- <div style="width:100%; height: 100%;  background-color: red">CIAO<br><br><br><br><br><br><br><br></div> -->
          <!-- <div style="width:200px; height:100%;background-color: red; overflow: auto; ">CIAO</div>
          <div style="width:200px; height:100%;background-color: yellow">CIAO</div> -->
          <!-- <div style="width:200px; background-color: yellow">CIAO</div> -->
         
        </div>
     </ng-container>
</div>
<!-- 
FLOATING BUTTONS
-->
<ng-content *ngIf="!pageLayoutDataService.loading && canvasLayoutDataService.width>=pageLayoutDataService.minSupportedWidth" select="[slot=actions]"></ng-content>